import { createFileRoute, redirect } from "@tanstack/react-router";

import { SpecialistsPage } from "@/features/directory/modules/specialists/specialists-page";
import { specialistsSearchSchema } from "@/features/directory/utils/search-params";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/book/")({
  // Who, where, when and for how much all live in the URL, so every view is a link (ADR 0036).
  validateSearch: specialistsSearchSchema,
  beforeLoad: ({ search }) => {
    if (search.tab === "events") throw redirect({ to: "/events", replace: true });
  },
  // Overrides the "Book" step of `route.tsx`, which resolves to the same /book.
  loader: () => ({ crumb: m.find_specialists() }),
  component: BookPage,
});

function BookPage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <SpecialistsPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
      onOpen={(specialistId, options) =>
        void navigate({ to: "/book/$specialistId", params: { specialistId }, search: options })
      }
    />
  );
}
